import { Link } from "react-router-dom";
import styled from "styled-components";
import { ChevronRight } from "lucide-react";
import { cPath } from "../../constants";

const Bar = styled.div`
  width: 100%;
  background: hsl(${({ theme }) => theme.colors.card});
  border-bottom: 1px solid hsl(${({ theme }) => theme.colors.border});
`;

const Inner = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layout.shellMax};
  margin: 0;
  padding: 0.75rem ${({ theme }) => theme.layout.shellPadX};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.375rem 0.5rem;
  font-size: clamp(0.875rem, 0.82rem + 0.2vw, 1rem);
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  text-align: left;
`;

const A = styled(Link)`
  flex-shrink: 0;
  &:hover {
    color: hsl(${({ theme }) => theme.colors.primary});
  }
`;

const Sep = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  opacity: 0.7;
`;

const Current = styled.span`
  color: hsl(${({ theme }) => theme.colors.foreground});
  min-width: 0;
  flex: 1 1 12rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function CouponBreadcrumb({ coupon, storeSlug }) {
  return (
    <Bar>
      <Inner>
        <A to={cPath("")}>Home</A>
        <Sep aria-hidden>
          <ChevronRight size={12} />
        </Sep>
        <A to={cPath(`store/${storeSlug}`)}>{coupon.storeName}</A>
        <Sep aria-hidden>
          <ChevronRight size={12} />
        </Sep>
        <Current title={coupon.title}>{coupon.title}</Current>
      </Inner>
    </Bar>
  );
}
